import { createOptionsFrom } from "@/lib/common/Option";

export const TransactionDetailsSortOrderLabels = {
	Chronological: "Chronological",
	Alphabetical: "Alphabetical"
} as const;

export type TransactionDetailsSortOrder = keyof typeof TransactionDetailsSortOrderLabels;

export const TransactionDetailsSortOrderOptions = createOptionsFrom(TransactionDetailsSortOrderLabels);
